import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  ErrorBox,
} from "@gearbox-protocol/deploy-tools-ui";
import { api } from "api";
import type { FC } from "react";
import { useNavigate } from "react-router-dom";
import { useAsyncFn } from "react-use";

interface ForkKillDialogProps {
  executionId: string;
  open?: boolean;
  onOpen?: (open: boolean) => void;
}

const ForkKillDialog: FC<ForkKillDialogProps> = props => {
  const { executionId, open, onOpen } = props;
  const navigate = useNavigate();

  const [{ loading, error }, submit] = useAsyncFn(async () => {
    await api.kill(executionId);
    navigate("/");
  }, [executionId, navigate]);

  return (
    <Dialog modal open={open} onOpenChange={onOpen}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Kill fork</DialogTitle>
          <DialogDescription>Please confirm fork kill</DialogDescription>
        </DialogHeader>

        {!!error && <ErrorBox error={error} />}

        <DialogFooter>
          <Button
            type="submit"
            variant="destructive"
            disabled={loading}
            loading={loading}
            onClick={submit}
          >
            Kill fork
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default ForkKillDialog;
